/**
 * Отправляет форму обратной связи на тестовый API.
 * @async
 * @function sendFeedback
 * @param {FormData} data - данные формы обратной связи
 * @returns {Promise<object>} Ответ от API в формате JSON
 * @throws {Error} Если запрос завершился неудачно
 */
export const sendFeedback = async (data: FormData): Promise<object> => {

  const obj = Object.fromEntries(data.entries());

  const res = await fetch("https://deepsum.io/api/v1/contact", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(obj),
  });

  if (!res.ok) {
    throw new Error("Failed to send feedback");
  }

  return res.json();
};
